<ng-container [ngSwitch]="data.documentType">
  <ng-container *ngSwitchCase="'hire'">
    <ng-container *ngIf="data.docket.account_reference; else hcHeader">
      <h1 mat-dialog-title>Email invoice to customer</h1>
    </ng-container>
    <ng-template #hcHeader>
      <h1 mat-dialog-title>Email hire contract to customer</h1>
    </ng-template>
  </ng-container>
  <ng-container *ngSwitchCase="'sale'">
    <h1 mat-dialog-title>Email sale invoice to customer</h1>
  </ng-container>
  <ng-container *ngSwitchCase="'booking'">
    <h1 mat-dialog-title>Email booking to customer</h1>
  </ng-container>
</ng-container>

<mat-dialog-content>
  <div class="flex flex-col w-full">
    <p>Please confirm the email address this document should be sent to:</p>
    <mat-form-field class="w-full my-8">
      <mat-label>Email address</mat-label>
      <input matInput [formControl]="email" />
      <mat-error *ngIf="email.hasError('required')"
        >Email address is required
      </mat-error>
      <mat-error *ngIf="email.hasError('email')"
        >Email address is invalid
      </mat-error>
    </mat-form-field>
  </div>
</mat-dialog-content>

<div mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close [disabled]="submitting">
    Cancel
  </button>
  <button
    mat-flat-button
    (click)="submit()"
    [disabled]="!email.valid || submitting"
  >
    Send
  </button>
</div>
